export default __webpack_public_path__ + "static/media/variations-castleCobble2.fd73c0b3.png";